import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

export const IconChevronDown: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      role="img"
      aria-labelledby="titleId"
      {...props}
      fill="none"
     aria-label="chevron down icon">
      {/* <title>chevron down icon</title> */}

      <path
        d="M0.97979 0.576867C1.1573 0.399355 1.43508 0.383218 1.63082 0.528454L1.6869 0.576867L6.00001 4.88975L10.3131 0.576867C10.4906 0.399355 10.7684 0.383218 10.9642 0.528454L11.0202 0.576867C11.1977 0.754378 11.2139 1.03215 11.0686 1.22789L11.0202 1.28397L6.35356 5.95064C6.17605 6.12815 5.89828 6.14429 5.70254 5.99905L5.64646 5.95064L0.97979 1.28397C0.784528 1.08871 0.784528 0.772129 0.97979 0.576867Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};
